import axios from "axios";
import { CompanyID } from "configs/AppConfig";

let BrandLogoService = {};

BrandLogoService.getCompanyLogo = async function () {
  try {
    const response = await axios({
      url: `/CompanyService.svc/GetCompanyById`,
      params: {
        CompanyID: CompanyID,
      },
    });
    return response;
  } catch (error) {
    console.log(error);
  }
};

BrandLogoService.updateBrandLogo = async function (data) {
  try {
    const response = await axios({
      method: "POST",
      url: "CompanyService.svc/UpdateCompanyLogo",
      data: data,
    });
    return response;
  } catch (error) {
    console.log(error);
  }
};

export default BrandLogoService;
